import(/* webpackMode: "eager", webpackExports: ["default"] */ "/work/repo/app/[locale]/announcements/components/AnnouncementsSection1.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/work/repo/app/[locale]/announcements/components/AnnouncementsSection2.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/work/repo/app/[locale]/announcements/components/AnnouncementsSection4.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/work/repo/app/[locale]/announcements/components/AnnouncementsSection5.jsx");
;
import(/* webpackMode: "eager" */ "/work/repo/app/[locale]/announcements/page.module.scss");
;
import(/* webpackMode: "eager" */ "/work/repo/assets/images/logos/1907.png");
;
import(/* webpackMode: "eager" */ "/work/repo/assets/images/logos/a-roasting-lab.png");
;
import(/* webpackMode: "eager" */ "/work/repo/assets/images/logos/ato.png");
;
import(/* webpackMode: "eager" */ "/work/repo/assets/images/logos/Bagcilar.png");
;
import(/* webpackMode: "eager" */ "/work/repo/assets/images/logos/Besiktas.png");
;
import(/* webpackMode: "eager" */ "/work/repo/assets/images/logos/Chakra.png");
;
import(/* webpackMode: "eager" */ "/work/repo/assets/images/logos/FreshScarfs.png");
;
import(/* webpackMode: "eager" */ "/work/repo/assets/images/logos/golden-beach-hotel.png");
;
import(/* webpackMode: "eager" */ "/work/repo/assets/images/logos/golden-sun-hotel.png");
;
import(/* webpackMode: "eager" */ "/work/repo/assets/images/logos/Kreft.png");
;
import(/* webpackMode: "eager" */ "/work/repo/assets/images/logos/ladonia-hotels-del-mare.png");
;
import(/* webpackMode: "eager" */ "/work/repo/assets/images/logos/Lescon.png");
;
import(/* webpackMode: "eager" */ "/work/repo/assets/images/logos/Loris.png");
;
import(/* webpackMode: "eager" */ "/work/repo/assets/images/logos/Mad.png");
;
import(/* webpackMode: "eager" */ "/work/repo/assets/images/logos/Manuka.png");
;
import(/* webpackMode: "eager" */ "/work/repo/assets/images/logos/mardan.png");
;
import(/* webpackMode: "eager" */ "/work/repo/assets/images/logos/marti-prime-beach-hotel.png");
;
import(/* webpackMode: "eager" */ "/work/repo/assets/images/logos/meri-hotel.png");
;
import(/* webpackMode: "eager" */ "/work/repo/assets/images/logos/Mesam.png");
;
import(/* webpackMode: "eager" */ "/work/repo/assets/images/logos/minted.png");
;
import(/* webpackMode: "eager" */ "/work/repo/assets/images/logos/Mudo.png");
;
import(/* webpackMode: "eager" */ "/work/repo/assets/images/logos/Mycoolman.png");
;
import(/* webpackMode: "eager" */ "/work/repo/assets/images/logos/Navlungo.png");
;
import(/* webpackMode: "eager" */ "/work/repo/assets/images/logos/Nu.png");
;
import(/* webpackMode: "eager" */ "/work/repo/assets/images/logos/ohara.png");
;
import(/* webpackMode: "eager" */ "/work/repo/assets/images/logos/PegPerego.png");
;
import(/* webpackMode: "eager" */ "/work/repo/assets/images/logos/Silva.png");
;
import(/* webpackMode: "eager" */ "/work/repo/assets/images/logos/Swandor.png");
;
import(/* webpackMode: "eager" */ "/work/repo/assets/images/logos/tarikediz.png");
;
import(/* webpackMode: "eager" */ "/work/repo/assets/images/logos/tatilsepeti.png");
;
import(/* webpackMode: "eager" */ "/work/repo/assets/images/logos/THY-Airlines.png");
;
import(/* webpackMode: "eager" */ "/work/repo/assets/images/logos/THY-Technic.png");
;
import(/* webpackMode: "eager" */ "/work/repo/assets/images/logos/TurkishCargo.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/work/repo/common/components/BackgroundVideo.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/work/repo/common/components/FAQCollapse.jsx");
;
import(/* webpackMode: "eager" */ "/work/repo/common/components/HorizontalBrandSection.module.scss");
;
import(/* webpackMode: "eager" */ "/work/repo/common/components/SectionWrapper.module.scss");
;
import(/* webpackMode: "eager" */ "/work/repo/common/components/SectionFAQ.module.scss");
;
import(/* webpackMode: "eager" */ "/work/repo/node_modules/next/dist/client/image-component.js");
